import { h, type Component, type VNodeChild } from 'vue';
import type { FormatterFactory } from '../types';
import { compilePath } from '../gridCell';

export interface LinkOptions {
  href?: string;
  hrefField?: string;
  displayMember?: string;
  valueMember?: string;
  className?: string;
  target?: string;
  attrs?: Record<string, any>;
}

const COMMAND_HREF = '#';

export const link: FormatterFactory = (options: LinkOptions = {}) => {
  const isCommand =
    !options.hrefField && (options.href ?? COMMAND_HREF) === COMMAND_HREF;
  const readHref = options.hrefField ? compilePath(options.hrefField) : null;
  const readDisplay = options.displayMember
    ? compilePath(options.displayMember)
    : null;
  const readValue = options.valueMember
    ? compilePath(options.valueMember)
    : null;

  const renderer = (
    props: { value: any; context: any },
    { slots }: { slots: Record<string, any> },
  ): VNodeChild => {
    const label = readDisplay
      ? asText(readDisplay(props.context))
      : slots.default
        ? undefined
        : asText(props.value);

    return h(
      'a',
      {
        href: readHref
          ? readHref(props.context)
          : (options.href ?? COMMAND_HREF),
        class: ['itp-data-grid__command', options.className],
        target: options.target,
        tabindex: 0,
        'data-value': readValue
          ? readValue(props.context)
          : asText(props.value),
        ...options.attrs,
      },
      label !== undefined ? label : slots.default?.(),
    );
  };

  renderer.props = ['value', 'context'];

  return {
    component: renderer as Component,
    props: (_value, context) => ({ context }),
    command: isCommand,
  };
};

function asText(value: any): string {
  return value == null ? '' : String(value);
}
